import { ALL_SPREAD_DEFINITIONS } from './all-spreads.js';
export const SPREADS_BY_INTENT = {
    daily: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.intent.includes('daily')),
    clarity: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.intent.includes('clarity')),
    timeline: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.intent.includes('timeline')),
    decision: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.intent.includes('decision')),
    relationship: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.intent.includes('relationship')),
    shadow: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.intent.includes('shadow')),
    healing: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.intent.includes('healing')),
    spiritual: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.intent.includes('spiritual')),
    yearly: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.intent.includes('yearly')),
    lilith: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.intent.includes('lilith')),
    kabbalistic: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.intent.includes('kabbalistic')),
    open: ALL_SPREAD_DEFINITIONS.filter((definition) => definition.intent.includes('open')),
};
//# sourceMappingURL=by-intent.js.map